import { useMedicalServiceMedicalDirectionsList } from '@insurance/api/queries'
import { useValidationsField } from '@insurance/hooks'
import { useDebounce } from '@shared/hooks'
import { Form, Select } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useHealthInsuranceValues } from './HealthInsuranceContext'

export const InsuranceCountriesSelect = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search)
  const { isEditable } = useHealthInsuranceValues()

  const { data, isLoading } = useMedicalServiceMedicalDirectionsList({
    search: debouncedSearch
  })

  return (
    <Form.Item
      label={t('choose_destination')}
      name="directions"
      rules={[required]}
    >
      <Select
        placeholder={t('choose_destination')}
        loading={isLoading}
        disabled={isEditable}
        options={data?.results.map(({ name, id }) => ({
          label: name,
          value: id
        }))}
        mode="multiple"
        onSearch={setSearch}
        onClear={() => setSearch('')}
        showSearch
        filterOption={false}
      />
    </Form.Item>
  )
}
